// extracted by mini-css-extract-plugin
module.exports = {"title":"HomePage_title__1sbYG","loader":"HomePage_loader__1VWK0"};